var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isOpen,
          expression: "isOpen",
        },
      ],
      staticClass: "search-criteria-list",
      class: _vm.isOpen ? "open" : "closed",
    },
    _vm._l(_vm.options, function (option, i) {
      return _c("div", { staticClass: "search-criteria-option" }, [
        _c("input", {
          attrs: {
            type: "radio",
            required: "required",
            id: `${_vm.id}-${option.name}`,
            name: _vm.name,
          },
          domProps: {
            checked: _vm.aValue === option.value,
            value: option.value,
          },
          on: { input: _vm.onInput },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: `${_vm.id}-${option.name}` } }, [
          _vm._v(_vm._s(option.name)),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }